import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentFinanceCollectionModel } from '../models/incident-finance-collection.model';

@Injectable()
export class CollectionIncidentService extends IncidentServiceBase<IncidentFinanceCollectionModel> {
    constructor() {
        super('IncidentFinanceCollection', () => new IncidentFinanceCollectionModel());
    }
}
